import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import nav from './modules/nav'
import common from './modules/common'
// import account from './modules/account'
import trip from './modules/trip'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  //组合模块
  modules: {
    user,
    nav,
    common,
    // account,
    trip
  }
})
